<div class="not-found-container">
    <div class="flex-wrapper">
        <img [src]="imagePath" />
        <span>{{ message }}</span>
    </div>
</div>
